export default __webpack_public_path__ + "static/media/circle.3df1c36c.png";